import { FileText, LayoutDashboard, Mail, Settings, Users } from 'lucide-react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from '@/shared/config/routes';
import { SITE } from '@/shared/config/site';
import { cn } from '@/shared/lib/utils/cn';
import { Seo } from '@/shared/seo';

const NAV = [
  { to: ROUTES.admin, label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: ROUTES.adminArticles, label: 'Articles', icon: FileText, end: false },
  { to: ROUTES.adminWriters, label: 'People', icon: Users, end: false },
  { to: ROUTES.adminSubscribers, label: 'Subscribers', icon: Mail, end: false },
  { to: ROUTES.adminSettings, label: 'Settings', icon: Settings, end: false },
];

/** Full-screen admin shell: persistent side navigation, no public header/footer. */
export function AdminLayout() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground antialiased sm:flex">
      {/* One declaration covers every /admin child route. */}
      <Seo title="Admin" noIndex />
      <aside className="border-b border-border p-4 sm:min-h-screen sm:w-56 sm:shrink-0 sm:border-b-0 sm:border-r">
        <Link
          to={ROUTES.home}
          className="mb-6 hidden font-display text-xl font-black italic tracking-tight transition-colors hover:text-amber-500 sm:block"
        >
          {SITE.name}
        </Link>
        <nav className="flex gap-1 overflow-x-auto sm:flex-col sm:overflow-visible">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-foreground text-background'
                    : 'text-muted-foreground hover:bg-zinc-100 hover:text-foreground dark:hover:bg-zinc-800',
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
